
<template>
  <div>

    <chc-loader ref="loader"></chc-loader>
    <datatable
        :source='vehicles'
        :searchCallback='searchCallback'
        :isLoading='isLoading'
        :paginate="state == 'summary'"
        :message="state == 'summary' ? 'No Results' : 'Press enter to search'"
      >
      <datatable-column
        v-show="state == 'summary'"
        v-for='(column, index) in columns'
        :id='column.id'
        :label='column.label'
        :key='index'
        >
      </datatable-column>

      <datatable-filter
        v-show="state == 'summary'"
        id='status_id'
        label='Status'
        :options='status.options'
        :defaultFilter="status.default"
        ref="statusFilter"
        v-on:options="updateOptions"
        @addFilter="addFilter"
        @removeFilter="removeFilter"
        >
      </datatable-filter>

      <template slot="searchLeft">
        <router-link :to="{name: 'VehicleAdd'}" class="secondary-action">+ Add New Vehicle</router-link>
      </template>

      <template slot="source_template" slot-scope="data">
          <tr v-show="state == 'summary'" @click="gotoRow(data.row.id)">
              <td>{{ data.row.ref_number }}</td>
              <td>{{ data.row.entry_date }}</td>
              <td>{{ data.row.donor_name }}</td>
              <td>{{ data.row.charity }}</td>
              <td>{{ data.row.year_make_model }}</td>
              <td>{{ data.row.vin }}</td>
              <td>{{ data.row.buyer }}</td>
              <td>{{ data.row.status }}</td>
          </tr>
      </template>
    </datatable>

    <div class="wrapper" v-if="state == 'call_search_message'">
      <span></span>
    </div>

  </div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import DatatableFilter from '@/components/Datatables/AppDatatableFilter'
import store from '@/store'
import auth from '@/auth'

export default {
  name: 'VehiclesSummary',
  props: {
    initialFilter: {
      type: String,
      default: null
    }
  },
  mounted () {
    if (this.initialFilter) {
      this.filters = [this.initialFilter]
    } else if (store.storage.vehicles_status !== null) {
      this.status = store.storage.vehicles_status
      this.filters = store.storage.vehicles_filters
    }
    if (this.user.user_role === 'call') {
      this.state = 'call_search_message'
    } else {
      this.state = 'summary'
    }
    Promise.all([
      store.functions.vehicles.vehiclesTable((response) => {
        if (response.data.no_load) {
          this.state = 'call_search_message'
          this.vehicles = [{}]
          return
        }
        this.state = 'summary'
        this.vehicles = response.data.table_data
        if (store.storage.vehicles_status == null || this.initialFilter) {
          this.status.options = Object.values(response.data.status_filter)
          this.status.default = Object.values(response.data.initial_filter)
          this.filters = Object.values(response.data.initial_filter)
          if (!this.initialFilter) {
            store.storage.vehicles_status = this.status
            store.storage.vehicles_filters = this.filters
          }
        }
        this.$nextTick(() => {
          this.$refs.statusFilter.init()
        })
      }, this.filters.length > 0 ? JSON.stringify(this.filters) : null)
    ]).catch(() => {
    }).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      user: auth.user,
      state: 'summary',
      columns: [
        { id: 'ref_number', label: 'Ref #' },
        { id: 'entry_date', label: 'Entry Date' },
        { id: 'donor_name', label: 'Donor Name' },
        { id: 'charity', label: 'Charity' },
        { id: 'year_make_model', label: 'Year/Make/Model' },
        { id: 'vin', label: 'VIN' },
        { id: 'buyer', label: 'Buyer' },
      ],
      status: {
        id: 'status',
        label: 'Status',
        options: [],
        default: []
      },
      isLoading: true,
      vehicles: [],
      filters: [],
      currentSearch: null,
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    DatatableFilter
  },
  methods: {
    gotoRow (rowId) {
      this.$refs.loader.show()
      this.$router.push({name: 'Vehicle', params: {vehicleId: rowId}}, () => {
        this.$refs.loader.hide()
      })
    },
    addFilter (option) {
      let index = this.filters.indexOf(option)
      if (index === -1) {
        this.filters.push(option)
      }
      this.refresh(this.currentSearch)
    },
    removeFilter (option) {
      let index = this.filters.indexOf(option)
      if (index !== -1) {
        this.filters.splice(index, 1)
      }
      this.refresh(this.currentSearch)
    },
    updateOptions (options) {
      store.storage.vehicles_status.default = options
    },
    searchCallback (filter) {
      this.currentSearch = filter
      this.refresh(this.currentSearch)
    },
    refresh (filter = '') {
      this.isLoading = true
      store.functions.vehicles.vehiclesTable((response) => {
        if (response.data.no_load) {
          this.state = 'call_search_message'
          this.vehicles = [{}]
          return
        }
        this.state = 'summary'
        this.vehicles = response.data.table_data
        if (this.user.user_role === 'call' && this.$refs.statusFilter.options.length === 0) {
          this.status.options = Object.values(response.data.status_filter)
          this.status.default = Object.values(response.data.initial_filter)
          this.filters = Object.values(response.data.initial_filter)
          store.storage.vehicles_status = this.status
          store.storage.vehicles_filters = this.filters
          this.$nextTick(() => {
            this.$refs.statusFilter.init()
          })
        }
      }, this.filters.length > 0 ? JSON.stringify(this.filters) : null, filter)
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehiclesSummary.vue